import { onScopeDispose } from "vue";
import { useRouter } from "vue-router";
import type { NavigationFailure, RouteLocationNormalized } from "vue-router";

import pinia from "@/plugins/PiniaPlugin";
import { useApplicationStore } from "@/stores/Application";

/**
 * Closes the content slide-over (article, trade alert, webinar) when the member moves to another page (UX roadmap #14).
 *
 * The slide-over sits outside <router-view> and is full-screen on phones. Nothing closed it on a route change, so the
 * author, product and 'Read more ->' links inside it, and Android Back, changed the page underneath while it stayed
 * on top. A query- or hash-only change (a list filter, the slide-over's own ?preview=) keeps the page, so it stays.
 * Call once, from the component that owns the slide-over; the hook goes with its scope.
 */
export function useCloseOverlaysOnNavigation(): void {
    const router = useRouter();
    const appStore = useApplicationStore( pinia );

    const removeAfterEach = router.afterEach( ( to: RouteLocationNormalized, from: RouteLocationNormalized, failure?: NavigationFailure | void ) => {
        if ( !failure && to.path !== from.path && appStore.contentModalVisible ) {
            appStore.clearSelectedContent();
        }
    } );

    onScopeDispose( removeAfterEach );
}
